import React, { memo, useState, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectFilterMenuStatus, makeSelectSpecialFilterDataArray, makeSelectSpecialFilterId } from '../selectors';
import { toggleSpecialFilterMenu } from './actions';
import ParentElement from '../../../components/FilterElement/ParentElement';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';

const key = 'special';

export const FilterCollapse = ({ onToggleSpecialFilterMenu, specialFilterMenuStatus, specialFilterDataArray }) => {
  useInjectReducer({ key, reducer });
  const [bubbleString, setBubbleString] = useState('');

  useEffect(() => {
    let newBubbleString = '';
    if (specialFilterDataArray.length > 0) {
      newBubbleString = specialFilterDataArray.join(', ');
    }
    if (bubbleString !== newBubbleString) {
      setBubbleString(newBubbleString);
    }
  }, [specialFilterDataArray]);

  /**
   * Main return function.
   */
  return (
    <div onClick={() => {
      onToggleSpecialFilterMenu(specialFilterMenuStatus)
    }}>
      <ParentElement title={'Durchführung'} bubble={bubbleString} status={specialFilterMenuStatus} />
    </div>
  );
};

FilterCollapse.propTypes = {
  SpecialFilterDataArray: PropTypes.array,
  onToggleSpecialFilterMenu: PropTypes.func,
  specialFilterMenuStatus: PropTypes.bool,
};

FilterCollapse.defaultProps = {
  specialFilterDataArray: [],
  onToggleSpecialFilterMenu: () => {},
  specialFilterMenuStatus: true,
};

const mapStateToProps = createStructuredSelector({
  specialFilterId: makeSelectSpecialFilterId(),
  specialFilterMenuStatus: makeSelectFilterMenuStatus(),
  specialFilterDataArray: makeSelectSpecialFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onToggleSpecialFilterMenu: (value) => {
      dispatch(toggleSpecialFilterMenu(value))
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterCollapse);
